<template>

  <div>
    <h4>{{ $t(`monitoring.resultName.${name}`) }}</h4>

    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr>
            <td>{{ $t('monitoring.reference-low') }}</td>
            <td><value-difference :old-value="previous[0] || 0" :new-value="values[0] || 0" /></td>
          </tr>
          <tr>
            <td>{{ $t('monitoring.reference-high') }}</td>
            <td><value-difference :old-value="previous[1] || 0" :new-value="values[1] || 0" /></td>
          </tr>
          <tr>
            <td>{{ $t('monitoring.last-value') }}</td>
            <td>TODO <!-- getLastValue --></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

  </div>

</template>

<script>
  import ValueDifference from '../../../shared/components/value-difference'

  export default {
    name: 'monitoring-result',

    props: [ 'name', 'values', 'previous' ],

    methods: {
      /*getLastValue (monitoringFunctionName, resultName, index) {
        return (this.item.monitoringSamples[monitoringFunctionName][index] &&
          this.item.monitoringSamples[monitoringFunctionName][index].results &&
          this.item.monitoringSamples[monitoringFunctionName][index].results[resultName])
      },*/
    },

    components: {
      ValueDifference
    }
  }
</script>

<style scoped lang="scss">

</style>
